import { defineComponent as _defineComponent } from 'vue'
import {onMounted, reactive} from "vue";
  import DocumentService, {Document, YearCount} from "@/service/DocumentService";
  import moment from "moment";
  import vuetify from "@/plugins/vuetify";


  
export default /*#__PURE__*/_defineComponent({
  __name: 'Archive',
  setup(__props) {

  const initialState = {
    years: new Array<YearCount>(),
    documentsByYear: {} as Record<number, Array<Document>>,
  };

  const state = reactive({...initialState});

  function loadDocuments(year?: number) {
    DocumentService.getDocuments(year)
      .then(response => {
        const {data, meta} = response.data;
        state.years = meta.years;
        if (meta.selectedYear !== undefined) {
          state.documentsByYear = {...state.documentsByYear, [meta.selectedYear]: data};
        }
      });
  }

  function onPanelChange(index: number | undefined) {
    if (index === undefined) {
      return;
    }
    const year = state.years[index]?.year;
    if (year !== undefined && !state.documentsByYear[year]) {
      loadDocuments(year);
    }
  }

  function download(file: Document) {
    DocumentService.download(file.id)
      .then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.filename);
          document.body.appendChild(link);
          link.click();
        }
      });
  }

  function formatTitle(file: Document) {
    const date = moment(file.documentDate).locale("DE");
    if (file.documentType === "INCOME_TAX") {
      const year = date.format("YYYY");

      let title = "Lohnsteuerbescheinigung";
      if (vuetify.framework.breakpoint.lgAndUp) {
        title += " " + year;
      }

      return {title: title, subtitle: year};
    } else {
      let title = date.format("MMMM");
      if (file.correctionNumber > 0) {
        title += " (" + file.correctionNumber + ". Korrektur)";
      }

      if (vuetify.framework.breakpoint.lgAndUp) {
        title += " - Entgeltabrechnung";
      }

      return {title: title, subtitle: "Entgeltabrechnung"};
    }
  }

  onMounted(() => {
    loadDocuments();
  });

return { __sfc: true,initialState, state, loadDocuments, onPanelChange, download, formatTitle }
}

})